import Games from '@/pages/Games.vue';
import authenticated from '@/middleware/authenticated';

export default [
    {
        path: '/games',
        name: 'games',
        component: Games,
        meta: { layout: 'Dashboard', middleware: [authenticated] },
    },
];
